import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import _ from 'lodash'
import queryString from 'query-string'
import { ErrorImage } from 'components/ErrorComponent'
import { actionCreators as geoPickerActionCreators } from 'reduxBits/geoPicker'
import { buildListPathname } from 'utils/url'
import { getLabel, getTreeParent, getGeoParams } from 'utils/parameters'
import EmptyState from 'components/EmptyState'
import { actionCreators as accountActionCreators } from 'reduxBits/account'
import { actionCreators as authActionCreators } from '@blocket/authentication-fe'
import CreateAdwatch from 'routes/List/FilterSave/CreateAdWatch/CreateAdWatch'

const TextButton = styled.button`
  width: auto;
  color: #4182c3;
  cursor: pointer;
`

const MessageText = styled.div`
  font-size: 16px;
  font-family: 'BlocketSans-Regular', sans-serif;
`

const Text = styled.p`
  font-size: 24px;
  font-family: 'BlocketSans-Medium', sans-serif;
`

export const EmptyStateList = ({
  location,
  categories,
  locations,
  history,
  setGeoPreference,
  byQueryKey,
  shippingAds,
}) => {
  const query = queryString.parse(location.search)
  const categoryLabel = getLabel(categories, query)
  const locationLabel = getLabel(locations, query)
  const searchQueryWord = _.trim(query.q)

  let messages = []
  if (categoryLabel !== categories.clearLabel) {
    const categoryParent = getTreeParent(categories, query)
    const categoryQuery = categoryParent.value
      ? { ...query, cg: categoryParent.value }
      : _.omit(query, ['cg'])
    const link = (
      <TextButton
        type="button"
        onClick={() => {
          history.push({
            ...location,
            pathname: buildListPathname(categoryQuery, byQueryKey),
            search: queryString.stringify(categoryQuery),
          })
        }}
      >
        {categoryParent.label}
      </TextButton>
    )
    messages.push(<p key="categoryMessage">Sök i {link} istället</p>)
  }
  if (locationLabel !== locations.clearLabel) {
    const locationParent = getTreeParent(locations, query)
    const newQuery = _.omit(query, [locationParent.nextQueryKey, 'ag'])
    const link = (
      <TextButton
        type="button"
        onClick={() => {
          setGeoPreference(getGeoParams(newQuery))
          history.push({
            ...location,
            pathname: buildListPathname(newQuery, byQueryKey),
            search: queryString.stringify(newQuery),
          })
        }}
      >
        {locationParent.label}
      </TextButton>
    )
    messages.push(<p key="locationMessage">Utöka sökningen till {link}</p>)
  }
  if (messages.length === 0) {
    messages = (
      <p>
        Prova att spara en bevakning. Du får ett meddelande så fort det du letar efter dyker upp hos
        oss.
      </p>
    )
  } else if (searchQueryWord) {
    messages.push(<p>eller ändra ditt sökord</p>)
  }

  return (
    <EmptyState>
      {(!shippingAds || (shippingAds && shippingAds.ads.length === 0)) && (
        <ErrorImage image="hittade-inga-annonser" />
      )}
      <Text>
        Inga annonser {searchQueryWord && `för "${searchQueryWord}"`} hittades{' '}
        {categoryLabel !== categories.clearLabel && `i ${categoryLabel}`}
      </Text>
      <MessageText>{messages}</MessageText>
      <CreateAdwatch />
    </EmptyState>
  )
}

EmptyStateList.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  categories: PropTypes.object.isRequired,
  locations: PropTypes.object.isRequired,
  setGeoPreference: PropTypes.func.isRequired,
  byQueryKey: PropTypes.object.isRequired,
  shippingAds: PropTypes.object.isRequired,
}

const mapStateToProps = (state) => ({
  loggedIn: state.account.user.loggedIn,
  searchSaved: state.classified.searchResults.searchSaved,
  adwatchId: state.classified.searchResults.adwatchId,
  querySignature: state.classified.searchResults.querySignature,
  categories: state.searchParams.byQueryKey.cg,
  locations: state.searchParams.byQueryKey.r,
  byQueryKey: state.searchParams.byQueryKey,
})

const mapDispatchToProps = (dispatch) => ({
  accountActions: bindActionCreators(accountActionCreators, dispatch),
  authActions: bindActionCreators(authActionCreators.blocketLoginHelper, dispatch),
  setGeoPreference: bindActionCreators(geoPickerActionCreators.setGeoPreference, dispatch),
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(EmptyStateList),
)
